module.exports = __webpack_public_path__ + "img/xt8@2x.9bca816e.png";